import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/queryClient';
import { csrfService } from '@/services';
import { ErrorBoundary } from '@/components/ui';
import { installChunkLoadRecoveryHandlers } from '@/utils/chunkLoadRecovery';
import './index.css';
import App from './App.tsx';

import { secureLogger } from '@/utils/secureLogger';
// Initialize CSRF protection on app startup
csrfService.initialize().catch((error) => {
  secureLogger.error('Failed to initialize CSRF protection:', error);
});
installChunkLoadRecoveryHandlers();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
